import { useTranslation } from 'react-i18next'

import { ClockIcon, EyeIcon, SlidersHorizontalIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import { getVisibilityBadges } from './helpers'
import * as Styles from './styles'

const BlockVisibilityBadges = ({ visibility, timeZone }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const { dateLabel, rulesLabel } = getVisibilityBadges({ visibility, t, language: i18n.language, timeZone })

  if (!dateLabel) return null

  return (
    <Styles.Container>
      <Chip
        label={dateLabel}
        Icon={visibility.limitByDate ? ClockIcon : EyeIcon}
        backgroundColor={theme.colors.success.surface}
        color={theme.colors.success.onSurface}
      />
      {rulesLabel && (
        <Chip
          label={rulesLabel}
          Icon={SlidersHorizontalIcon}
          backgroundColor={theme.colors.info.surface}
          color={theme.colors.info.onSurface}
        />
      )}
    </Styles.Container>
  )
}

export default BlockVisibilityBadges
